import HeroSection from "@/components/MCP/HeroSection";
import EvolutionSection from "@/components/MCP/EvolutionSection";
import BusinessImpactSection from "@/components/MCP/BusinessImpactSection";
import DataSourcesSection from "@/components/MCP/DataSourcesSection";
import ChatDemoSection from "@/components/MCP/ChatDemoSection";
import HowItWorksSection from "@/components/MCP/HowItWorksSection";
import AICapabilitiesSection from "@/components/MCP/AICapabilitiesSection";
import ContactFormSection from "@/components/MCP/ContactFormSection";
import { NavbarTheme } from "@/contexts/NavbarThemeContext";

function MCP() {
  return (
    <div className="flex flex-col gap-[60px] bg-white font-inter min-[478px]:gap-[100px] xl:gap-[120px]">
      <NavbarTheme theme="new" />
      <HeroSection />
      <EvolutionSection />
      <BusinessImpactSection />
      <DataSourcesSection />
      <ChatDemoSection />
      <HowItWorksSection />
      <AICapabilitiesSection />
      <ContactFormSection />
    </div>
  );
}

export default MCP;
